import React from "react";
import classNames from "classnames";

function SectionHeading({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <span
      className={classNames(
        "mb-1 block text-sm font-semibold uppercase tracking-wide text-[#666679]",
        className,
      )}
    >
      {children}
    </span>
  );
}

export default SectionHeading;
